import { DefaultOptionType } from "antd/es/select";
import React from "react";
import { apiLoadPersonList } from "src/common/apiPerson";
import { apiObjUrl } from "src/common/apiUrl";
import { makeLabels4Leaves } from "src/common/attributes/makeAttrLabel/makeLabels4Leaves";
import { ZAttrLabelTreeData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelTreeData";
import { filterAttrLabelData } from "src/common/attributes/makeAttrLabel/utils/filterAttrLabelData";
import { getAllLabelDataAttributes } from "src/common/attributes/makeAttrLabel/utils/getAllLabelDataAttributes";
import { getLeaves } from "src/common/attributes/makeAttrLabel/utils/getLeaves";
import {
  seedSeparators,
  ZSeparator,
} from "src/common/attrView/viewFormItems/Separator";
import { makeDictionary } from "src/common/makeDictionary";
import { restWithObjectVersion } from "src/common/restWithObjectVersion";
import { getTypesMap } from "src/references/getTypesMap";
import { AttrTypeName } from "src/types/AttrType";
import { zObjectItem } from "src/types/ZObjectItem";
import { ZUid } from "src/types/zUid";
import styles from "./PersonSelect.module.less";

export const loadPersonsOptions = async (
  roleIds4Load: ZUid[],
  objectId: ZUid,
  userIds?: ZUid[],
  rolesViewAtts?: Record<ZUid, ZUid[]>,
  separator?: ZSeparator,
): Promise<DefaultOptionType[]> => {
  const persons = await apiLoadPersonList(
    { roleIds: roleIds4Load, userIds: userIds ?? [], objectId },
    { withLabels: true },
  );
  const typesMap = await getTypesMap();
  const resp = await restWithObjectVersion.get(apiObjUrl("/roles"));
  const roles = zObjectItem.array().parse(resp.data);
  const rolesMap = makeDictionary(roles, ({ roleId }) => String(roleId));

  return persons.content
    .map(({ labelData, userId, roleIds }) => {
      const userRole = rolesMap[roleIds?.[0] || ""]?.id;
      if (!userRole) return null;
      const userRoleViewAttrs = rolesViewAtts?.[userRole];
      if (!userRoleViewAttrs) return null;
      const attrLabelData = userRoleViewAttrs
        .map((attrId) =>
          labelData?.labels.find((ld) => String(ld.attrId) === String(attrId)),
        )
        .filter((e) => !!e) as ZAttrLabelTreeData[];
      const allAttributes = getAllLabelDataAttributes(persons.attributesLabels);
      const filtered = filterAttrLabelData(
        attrLabelData,
        allAttributes,
        typesMap,
        [AttrTypeName.image, AttrTypeName.file],
      );
      const leaves = filtered.map((data) => getLeaves(data)).flat();
      const label4Leaves = makeLabels4Leaves(leaves, allAttributes, typesMap);
      const searchTextFilter = leaves
        .map((leaf) => leaf.labels?.join(""))
        .join("");
      const label = (
        <div className={styles.label}>
          {seedSeparators(
            label4Leaves.map((l, i) => ({ content: l, key: i })),
            /**
             * тут потребуется изменить разделитель на тот, что указан в настройках
             */
            separator || "comma",
          )}
        </div>
      );
      return {
        label,
        value: userId,
        searchText: searchTextFilter.toLowerCase(),
      };
    })
    .filter((e) => !!e) as DefaultOptionType[];
};
